import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { FaArrowUp, FaUsers, FaCalendarAlt } from "react-icons/fa";
import "../styles/EDCCCompanyList.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ErgonomicCertification = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalEntries, setTotalEntries] = useState(0);
  const baseURL = process.env.REACT_APP_BASEURL || "http://localhost:4890";

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // const fetchEDCCData = async (page = 1, limit = 10, searchQuery = "") => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`${baseURL}/memberpayementdone`, {
  //       params: {
  //         page,
  //         limit,
  //         search: searchQuery,
  //       },
  //     });
  //     const { data: responseData, pagination } = response.data;
  //     setData(responseData);
  //     setFilteredData(responseData); // Initialize filteredData with fetched data
  //     setTotalPages(pagination.totalPages);
  //     setCurrentPage(pagination.page);
  //     setTotalEntries(pagination.totalEntries || pagination.total);
  //     setError(null);
  //   } catch (err) {
  //     setError("Failed to fetch data. Please try again.");
  //     console.error("Error fetching EDCC data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

const fetchEDCCData = async () => {
  setLoading(true);
  try {
    const response = await axios.get(`${baseURL}/memberpayementdoneCMS`, {
    
    });

    const { data: responseData } = response.data;
    setData(responseData);
    setFilteredData(responseData);
    setError(null);
    setTotalEntries(responseData.length);
    setTotalPages(Math.ceil(responseData.length / limit)); // Add this line
  } catch (err) {
    setError("Failed to fetch data. Please try again.");
    console.error("Error fetching EDCC data:", err);
  } finally {
    setLoading(false);
  }
};

// Update the useEffect to recalculate totalPages when limit changes
useEffect(() => {
  fetchEDCCData();
}, []); // Remove currentPage and limit from dependencies

// Add a new useEffect to recalculate totalPages when limit changes
useEffect(() => {
  setTotalPages(Math.ceil(filteredData.length / limit));
}, [limit, filteredData.length]);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

const handlePageChange = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) {
    setCurrentPage(newPage);
  }
};

 const handleLimitChange = (e) => {
  setLimit(parseInt(e.target.value));
  setCurrentPage(1);
};

const handleSearchChange = (e) => {
  const searchValue = e.target.value;
  setSearch(searchValue);
  setCurrentPage(1);

  if (searchValue.trim() === "") {
    setFilteredData(data);
    setTotalEntries(data.length);
    setTotalPages(Math.ceil(data.length / limit));
  } else {
    const filtered = data.filter(
      (item) =>
        item.name_of_organization
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        item.range_of_products?.some(
          (product) =>
            product.heading
              ?.toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            product.sub_items?.some((sub) =>
              sub.toLowerCase().includes(searchValue.toLowerCase())
            )
        ) ||
        item.renewed_range_of_products?.some(
          (product) =>
            product.heading
              ?.toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            product.sub_items?.some((sub) =>
              sub.toLowerCase().includes(searchValue.toLowerCase())
            )
        ) ||
        item.district?.district_name
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        item.state?.state_name
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        formatDate(item.valid_till)
          .toLowerCase()
          .includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setTotalPages(Math.ceil(filtered.length / limit));
  }
};

  // Format date to DD MMMM YYYY
  // const formatDate = (dateString) => {
  //   if (!dateString) return "N/A";
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString("en-GB", {
  //     day: "2-digit",
  //     month: "long",
  //     year: "numeric",
  //   }).toUpperCase();
  // };
  const formatDate = (date) => {
  if (!date) return 'N/A';
  
  // If it's already a string (like "30TH SEPTEMBER 2027"), return as is
  if (typeof date === 'string' && date.match(/\d+(ST|ND|RD|TH)/i)) {
    return date;
  }
  
  // If it's a Date object or ISO string, format it
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
      return date; // Return original if invalid date
    }
    
    // Format as needed (e.g., "DD/MM/YYYY" or your preferred format)
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    return date; // Return original value if formatting fails
  }
};

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="company-list-content-section">
            <Container>
              <h1 className="company-list-section-title">
                Certification for Ergonomically Designed Products Industries
                Registered with AIOTA
              </h1>

              <p className="content-text">
                AIOTA esigned Ranges of Furniture
                has been provided after carrying out inspection for verification as
                per norms to the following:
              </p>

              <div className="table-controls">
                <div className="entries-control">
                  <span className="entries-text">Show</span>
                  <select
                    className="entries-select"
                    value={limit}
                    onChange={handleLimitChange}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="entries-text">entries</span>
                </div>
                <div className="search-control">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="search-input"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>

              {loading && <p>Loading...</p>}
              {error && <p className="text-danger">{error}</p>}
              {!loading && !error && (
                <div className="table-responsive">
                  <table className="table certification-table">
                    <thead>
                      <tr>
                        <th style={{ width: "25%" }}>Company</th>
                        <th style={{ width: "45%" }}>Furniture Type</th>
                        <th style={{ width: "15%" }}>Place</th>
                        <th style={{ width: "15%" }}>Validity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.slice((currentPage - 1) * limit, currentPage * limit).map((item) => {
                          // Build deduplicated product list: renewed overrides registration by heading
                          const productMap = new Map();
                          (item.range_of_products || []).forEach((p) => {
                            productMap.set(p.heading, p);
                          });
                          (item.renewed_range_of_products || []).forEach((p) => {
                            productMap.set(p.heading, p);
                          });
                          const allProducts = Array.from(productMap.values());

                          if (allProducts.length === 0) {
                            return (
                              <tr key={item._id}>
                                <td>{item.name_of_organization || "N/A"}</td>
                                <td>N/A</td>
                                <td>
                                  {item.address_to_be_printed_on_certificate
                                    || (item.district?.district_name && item.state?.state_name
                                      ? `${item.district.district_name}, ${item.state.state_name}`
                                      : item.flat_house_building)
                                    || "N/A"}
                                </td>
                                <td>{formatDate(item.valid_till)}</td>
                              </tr>
                            );
                          }

                          return allProducts.map((product, idx) => {
                            const subItems =
                              product.sub_items && product.sub_items.length > 0
                                ? ` (${product.sub_items.join(", ")})`
                                : ""; 
                            return (
                              <tr key={`${item._id}-${idx}`}>
                                {idx === 0 ? (
                                  <td rowSpan={allProducts.length}>
                                    {item.name_of_organization || "N/A"}
                                  </td>
                                ) : null}
                                <td>
                                  • {product.heading}{subItems}
                                </td>
                                {idx === 0 ? (
                                  <td rowSpan={allProducts.length}>
                                    {item.address_to_be_printed_on_certificate
                                      || (item.district?.district_name && item.state?.state_name
                                        ? `${item.district.district_name}, ${item.state.state_name}`
                                        : item.flat_house_building)
                                      || "N/A"}
                                  </td>
                                ) : null}
                                <td>{formatDate(product.valid_till || item.valid_till)}</td>
                              </tr>
                            );
                          });
                        })
                      ) : (
                        <tr>
                          <td colSpan="4">No records found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
<div className="table-controls">
  <span>
    Showing {(currentPage - 1) * limit + 1} to{" "}
    {Math.min(currentPage * limit, totalEntries)} of {totalEntries} entries
  </span>

  <div className="pagination">
    <button
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
    >
      Previous
    </button>

    {/* Render page numbers: 1, ..., current-1, current, current+1, ..., last */}
    {totalPages > 0 &&
      Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
        const showPage =
          page === 1 ||
          page === totalPages ||
          Math.abs(page - currentPage) <= 1;

        const showEllipsis =
          !showPage &&
          ((page === currentPage - 2 && currentPage > 3) ||
            (page === currentPage + 2 && currentPage < totalPages - 2));

        if (showPage) {
          return (
            <button
              key={page}
              className={currentPage === page ? "active" : ""}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          );
        }
        if (showEllipsis) {
          return <span key={`ellipsis-${page}`}>...</span>;
        }
        return null;
      })}

    <button
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalPages || totalEntries === 0}
    >
      Next
    </button>
  </div>
</div>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default ErgonomicCertification;